import { SettingConst } from '../../types';

/**
 * This setting stores a list of layoutElement.onClickEventName which we would want to have styling on for
 * the Markets showtime homepage.
 */
export const FAIRE_MARKET_STYLED_HOMEPAGE_ONCLICKEVENTNAME =
  'FAIRE_MARKET_STYLED_HOMEPAGE_ONCLICKEVENTNAME' as SettingConst<
    'FAIRE_MARKET_STYLED_HOMEPAGE_ONCLICKEVENTNAME',
    Array<string>,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
